/** Matches the storage format server-side extraction expects — @[Display Name](memberId). */
export const MENTION_PATTERN = /@\[([^\]]+)\]\(([0-9a-f-]{36})\)/g;

/** Plain display text for anywhere a mention marker shouldn't render as a chip (e.g. a one-line preview). */
export const stripMentionMarkers = (text) => (text || '').replace(MENTION_PATTERN, '@$1');
